<template>
    <b-modal id="selected-files-modal"
             title="선택된 파일 목록"
             hide-footer
             size="lg"
             modal-class="default-modal"
             @hide="closeModal"
    >
        <template #modal-header>
            <div class="d-flex align-items-center justify-content-between w-100">
                <h5 class="mb-0">선택된 파일 ({{ selectedFiles.length }}개)</h5>
                <b-button variant="link" class="p-0" :disabled="downloading" @click="closeModal">
                    <i class="bi bi-x-lg"></i>
                </b-button>
            </div>
        </template>

        <div class="selected-files-container">
            <div v-if="selectedFiles.length === 0" class="text-center text-muted py-5">
                <i class="bi bi-file-earmark-x" style="font-size: 3rem;"></i>
                <p class="mt-3">선택된 파일이 없습니다.</p>
            </div>

            <div v-else class="selected-files-list">
                <div v-for="file in selectedFiles" 
                     :key="file.id" 
                     class="selected-file-item d-flex justify-content-between align-items-center"
                >
                    <div class="file-info">
                        <div class="file-name text-truncate" :title="file.filename">
                            <i class="bi bi-file-earmark mr-2"></i>
                            {{ file.filename }}
                        </div>
                        
                        <div class="file-meta text-muted">
                            <span class="file-size">{{ formatFileSize(file.fileSize) }}</span>
                            <b-badge class="file-user">{{ file.requestUserId }}</b-badge>
                        </div>
                    </div>
                    <b-button title="제거"
                              variant="icon" 
                              size="sm" 
                              :disabled="downloading"
                              @click="removeFile(file.id)"
                    >
                        <fa icon="times"></fa>
                    </b-button>
                </div>
            </div>
        </div>

        <div class="modal-actions mt-4 d-flex justify-content-between align-items-center">
            <div class="total-size">
                <strong>총 크기:</strong> {{ formatFileSize(totalSize) }}
                <b-badge v-if="totalSize > sizeWarningThreshold" variant="warning" class="ml-2">
                    대용량 파일
                </b-badge>
            </div>
            <div class="action-buttons">
                <b-button variant="outline-secondary" class="mr-2" :disabled="downloading" @click="closeModal">
                    닫기
                </b-button>
                <b-button v-if="selectedFiles.length > 0"
                          variant="outline-danger" 
                          class="mr-2"
                          :disabled="downloading"
                          @click="clearAll"
                >
                    전체 해제
                </b-button>
                <b-button v-if="selectedFiles.length > 0"
                          variant="outline-primary"
                          class="mr-2"
                          :disabled="downloading"
                          @click="downloadSeparately"
                >
                    개별 다운로드
                </b-button>
                <b-button v-if="selectedFiles.length > 0"
                          variant="primary"
                          class="mr-2"
                          :disabled="downloading"
                          @click="downloadAsZip"
                >
                    ZIP 다운로드
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { SIZE_WARNING_THRESHOLD } from './data';

export default {
    name: 'DownloadCenterModal',
    props: {
        selectedFiles: {
            type: Array,
            default: () => []
        },
        downloading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        totalSize() {
            return this.selectedFiles.reduce((sum, file) => sum + (file.fileSize || 0), 0);
        },
        sizeWarningThreshold() {
            return SIZE_WARNING_THRESHOLD;
        }
    },
    methods: {
        closeModal() {
            this.$bvModal.hide('selected-files-modal');
        },
        removeFile(id) {
            this.$emit('remove-file', id);
        },
        clearAll() {
            this.$emit('clear-all');
            this.closeModal();
        },
        downloadSeparately() {
            this.$emit('download', { files: this.selectedFiles, asZip: false });
            this.closeModal();
        },
        downloadAsZip() {
            this.$emit('download', { files: this.selectedFiles, asZip: true });
            this.closeModal();
        },
        formatFileSize(bytes) {
            if (bytes === null || bytes === undefined) return 'Unknown';
            if (bytes === 0) return '0 B';
            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        }
    }
};
</script>

<style lang="scss" scoped>
.selected-files-container {
    max-height: 400px;
    overflow-y: auto;
}

.selected-files-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.selected-file-item {
    padding: 12px 16px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.file-info {
    flex: 1;
    min-width: 0;
    
    .file-name {
        font-weight: 500;
        max-width: 400px;
    }
    
    .file-meta {
        font-size: 12px;
        margin-top: 2px;
        margin-left: 8px;
        display: flex;
        gap: 12px;
        .file-user {
            line-height: unset !important;
        }
    }
}

.modal-actions {
    border-top: 1px solid #e9ecef;
    padding-top: 16px;
}

.total-size {
    color: #495057;
}
</style>

